import type { Translations } from "../types";

const ur: Translations = {
  "meta.title": "ملک کے نقشے کے مطابق کلکس",
  "meta.description":
    "انٹرایکٹو عالمی نقشہ: ہر ملک کے لیے مفت کلکس کے ساتھ ساتھ Stripe، PayPal اور Buy Me a Coffee کے ذریعے ادا شدہ تعاون۔",

  "app.title": "ملک کے نقشے کے مطابق کلکس",

  "map.intro":
    "کسی ملک کو مفت ووٹ دینے کے لیے نقشے پر کلک کریں، یا اسے مالی تعاون بھیجیں - دونوں ہی نیچے دیے گئے مشترکہ لیڈر بورڈ میں شمار ہوتے ہیں۔ یہ نقشہ صرف اس ایپ کے اندر ملنے والی حمایت کو ظاہر کرتا ہے، نہ کہ کسی ملک کی اصل قومی دولت یا GDP کو۔",
  "map.verifying": "تصدیق ہو رہی ہے …",
  "map.confirmNotRobot": "مفت کلکس شامل کرنے سے پہلے، جلدی سے تصدیق کریں کہ آپ روبوٹ نہیں ہیں:",
  "map.tryAgain": "دوبارہ کوشش کریں",
  "map.registeringClick": "کلک درج کی جا رہی ہے …",
  "map.selectedCountry": "منتخب ملک: {name}۔",
  "map.selectFirstFeedback": "ملک منتخب کر لیا گیا ہے۔ مفت کلک شامل کرنے کے لیے، پہلے نیچے تصدیق کریں کہ آپ روبوٹ نہیں ہیں۔",
  "map.verificationExpired": "تصدیق کی میعاد ختم ہو گئی - دوبارہ تصدیق کریں کہ آپ روبوٹ نہیں ہیں۔",
  "map.slowDown": "کچھ سست روی اختیار کریں - اگلی کلک سے پہلے ذرا انتظار کریں۔",
  "map.clickFailed": "کلک درج نہیں ہو سکی۔ براہ کرم دوبارہ کوشش کریں۔",
  "map.clickErrorGeneric": "کلک درج کرنے میں خرابی۔",
  "map.leaderboardHeading": "ممالک کا لیڈر بورڈ",
  "map.emptySelection": "کلک کرنے یا تعاون کرنے کے لیے نقشے پر کوئی ملک منتخب کریں۔",
  "map.loadingData": "ڈیٹا لوڈ ہو رہا ہے …",

  "worldmap.loadError": "نقشہ لوڈ نہیں ہو سکا۔",
  "worldmap.resetZoom": "زوم ری سیٹ کریں",
  "worldmap.resetButton": "⤾ ری سیٹ",
  "worldmap.loadingMap": "نقشہ لوڈ ہو رہا ہے …",
  "worldmap.unknownCountry": "نامعلوم",
  "worldmap.ariaClicks": "{name}: {clicks} کلکس",
  "worldmap.tooltipClicks": "{clicks} کلکس",

  "legend.fewer": "کم کلکس",
  "legend.more": "زیادہ کلکس",

  "list.empty": "ابھی تک کوئی کلک نہیں۔ سب سے پہلے آپ بنیں!",
  "list.ariaLabel": "کلکس کے لحاظ سے ممالک کا لیڈر بورڈ",

  "human.siteKeyMissing": "VITE_TURNSTILE_SITE_KEY سیٹ نہیں ہے - ترتیب کے لیے README دیکھیں۔",
  "human.verificationFailedGeneric": "تصدیق ناکام ہو گئی۔",
  "human.networkError":
    "تصدیق تک رسائی حاصل نہیں ہو سکی (نیٹ ورک خرابی) - VITE_SUPABASE_URL چیک کریں، دیکھیں کہ verify-human ڈیپلائے ہو چکی ہے، اور ALLOWED_ORIGIN؛ README/NAVODILA ملاحظہ کریں۔",
  "human.verificationFailedRetry": "تصدیق ناکام ہو گئی، دوبارہ کوشش کریں۔",

  "provider.stripe": "💳 کارڈ (Stripe)",
  "provider.paypal": "🅿️ PayPal",
  "provider.buymeacoffee": "☕ Buy Me a Coffee",

  "panel.selectedCountryLabel": "منتخب ملک",
  "panel.currentlyRanked": "فی الحال درجہ #{rank}",
  "panel.shareCopied": "کاپی ہو گیا ✓",
  "panel.shareShared": "شیئر ہو گیا ✓",
  "panel.shareButton": "🔗 شیئر کریں",

  "panel.tableClicks": "کلکس",
  "panel.tableFree": "مفت",
  "panel.tablePaid": "ادا شدہ",
  "panel.rowAllTime": "ہر وقت",
  "panel.rowThisYear": "اس سال",
  "panel.rowThisWeek": "اس ہفتے",
  "panel.rowToday": "آج",

  "panel.totalCombined": "مجموعی کل:",
  "panel.totalSupport": "کل تعاون:",

  "panel.paymentMethod": "ادائیگی کا طریقہ",
  "panel.noPaymentMethod": "فی الحال کوئی ادائیگی کا طریقہ دستیاب نہیں ہے۔",
  "panel.supportAmount": "تعاون کی رقم (EUR)",
  "panel.amountRange": "رقم {min} اور {max} کے درمیان ہونی چاہیے۔",
  "panel.quickAmount": "{eur} €",
  "panel.estimatedClicks": "تخمینی ادا شدہ کلکس:",
  "panel.ratioInfo":
    "تناسب: {a} = {b} کلکس (مثلاً {c} = {d} کلکس)۔ یہ ادائیگی سے پہلے صرف ایک تخمینہ ہے - کلکس کی حتمی تعداد ہمیشہ سرور کی جانب سے، اصل تصدیق شدہ ادائیگی کی بنیاد پر، شمار اور تصدیق کی جاتی ہے۔",
  "panel.preparing": "تیاری ہو رہی ہے …",
  "panel.continueWith": "{provider} کے ساتھ جاری رکھیں",
  "panel.choosePaymentMethod": "ادائیگی کا طریقہ منتخب کریں",
  "panel.bmcUsernameMissing": "VITE_BMC_USERNAME سیٹ نہیں ہے - ترتیب کے لیے README دیکھیں۔",
  "panel.paypalClientIdMissing": "VITE_PAYPAL_CLIENT_ID سیٹ نہیں ہے - ترتیب کے لیے README دیکھیں۔",

  "panel.paypalAmountInfo": "رقم: {amount} (تخمینی {clicks} کلکس)۔ نیچے دیے گئے PayPal بٹن سے ادائیگی مکمل کریں۔",
  "panel.back": "← واپس",

  "panel.bmcWarningTitle": "⚠️ BuyMeCoffee پر جانے سے پہلے:",
  "panel.bmcWarningBody":
    "چیک آؤٹ کے وقت نیچے دیا گیا کوڈ میسج/نوٹ کے خانے میں پیسٹ کریں — یہی واحد طریقہ ہے جس سے ہمیں معلوم ہو گا کہ آپ کس ملک کی حمایت کر رہے ہیں۔ کوڈ کے بغیر، ہم ادائیگی کو کسی بھی ملک سے منسوب نہیں کر سکتے۔",
  "panel.copy": "کاپی کریں",
  "panel.copied": "کاپی ہو گیا ✓",
  "panel.suggestedAmount": "تجویز کردہ رقم:",
  "panel.bmcAmountNote":
    "(تخمینی {clicks} کلکس)۔ بدقسمتی سے BuyMeCoffee لنک کے ذریعے رقم منتقل کرنے کی سہولت نہیں دیتا — اسے ان کی سائٹ پر خود درج/منتخب کریں۔ کلکس کی اصل تعداد ہمیشہ اس رقم سے شمار کی جاتی ہے جو آپ واقعی BuyMeCoffee پر بھیجتے ہیں، اس تخمینے سے نہیں۔",
  "panel.openBmc": "BuyMeCoffee کھولیں اور جاری رکھیں →",
  "panel.waitingProvider": "ادائیگی فراہم کنندہ کی جانب سے ادائیگی کی تصدیق کا انتظار ہے …",
  "panel.waitingConfirmation": "ادائیگی کی تصدیق کا انتظار ہے …",
  "panel.timedOut":
    "جانچ کا وقت ختم ہو گیا۔ اگر آپ نے ادائیگی مکمل کر لی ہے تو سرور کو تصدیق ملتے ہی نقشہ اپ ڈیٹ ہو جائے گا - اس میں بعض اوقات کچھ زیادہ وقت لگ سکتا ہے۔",
  "panel.checkAgain": "دوبارہ چیک کریں",

  "panel.cancelled": "ادائیگی منسوخ ہو گئی یا مکمل نہیں ہو سکی۔ نقشے میں کوئی تبدیلی نہیں آئی۔",
  "panel.tryAgain": "دوبارہ کوشش کریں",

  "panel.confirmed": "✅ تعاون کی تصدیق ہو گئی!",
  "panel.confirmedBody": "{country} کو {amount} کے عوض {clicks} ادا شدہ کلکس ملیں۔",

  "panel.errorPreparingSupport": "آپ کا تعاون تیار کرنے میں خرابی۔",
  "panel.errorPreparingPayment": "ادائیگی تیار کرنے میں خرابی۔",
  "panel.errorConfirmingPayment": "ادائیگی کی تصدیق میں خرابی۔",
  "panel.errorPayingPaypal": "PayPal کے ذریعے ادائیگی میں خرابی۔",

  "share.unranked": "{flag}{country} کو عالمی نقشے پر آپ کی حمایت درکار ہے!\nاسے لیڈر بورڈ میں آگے بڑھنے میں مدد کریں 👇",
  "share.rank1": "{flag}{country} اس وقت #1 پر ہے!\nہمیں سرِفہرست رہنے میں مدد کریں 👇",
  "share.rankN": "{flag}{country} اس وقت #{rank} پر ہے!\nہمیں #1 تک پہنچنے میں مدد کریں 👇",

  "language.switcherLabel": "زبان",
};

export default ur;
